import React, { useEffect, useMemo, useRef } from 'react';
import { Image, ImageBackground, Pressable } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import PropTypes from 'prop-types';

const CdnImageBackground = ({
    enableOverlay = false,
    gradientColors = ['rgba(23,30,37,0)', 'rgba(6,9,11,.6)'],
    gradientLocations = [0.1, 0.99],
    imageDimensions,
    onPress,
    setImageDimensions,
    style,
    uri,
    usePointer = false,
    width,
    ...rest
}) => {
    const selfRef = useRef();
    const validUri = uri?.startsWith('http') ? uri : `https:${uri}`;
    const imageSrc = validUri?.indexOf('?') !== -1 ? `${validUri}&width=${width}` : `${validUri}?width=${width}`;

    const linearGradient = useMemo(
        () => (
            <LinearGradient
                colors={gradientColors}
                locations={gradientLocations}
                style={{
                    bottom: 0,
                    left: 0,
                    height: '100%',
                    position: 'absolute',
                    right: 0,
                    top: 0,
                    width: '100%'
                }}
                testID='CdnImageBackground.LinearGradient'
            />
        ),
        [gradientColors, gradientLocations]
    );

    useEffect(() => {
        Image.getSize(
            imageSrc,
            (w, height) => {
                if (w < width) {
                    w = width;
                }

                setImageDimensions(() => {
                    return { height: Math.floor(height), width: Math.floor(w) };
                });
            },
            error => console.log(`Error loading image: ${error}`)
        );
    }, [imageSrc, setImageDimensions, width]);

    return (
        <Pressable ref={selfRef} onPress={onPress}>
            <ImageBackground
                style={{ cursor: usePointer ? 'pointer' : 'auto', height: imageDimensions?.height, width: imageDimensions?.width, ...style }}
                source={{ uri: imageSrc }}
                dataSet={{ umbracoComponentName: rest.dataSet?.umbracoComponentName }}
            >
                {enableOverlay && linearGradient}
                {rest.children}
            </ImageBackground>
        </Pressable>
    );
};

CdnImageBackground.propTypes = {
    enableOverlay: PropTypes.bool,
    gradientColors: PropTypes.arrayOf(PropTypes.string),
    gradientLocations: PropTypes.arrayOf(PropTypes.number),
    imageDimensions: PropTypes.shape({
        height: PropTypes.number,
        width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    }),
    onPress: PropTypes.func,
    uri: PropTypes.string.isRequired,
    usePointer: PropTypes.bool,
    setImageDimensions: PropTypes.func,
    style: PropTypes.object,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

export default CdnImageBackground;
